import React, {ReactNode} from "react";
import {Images} from "../../../../core/utilities/images";
import "./ModalHeader.scss";

interface IProps {
  className: string;
  text: string | ReactNode;
  icon?: ReactNode;
}

const ModalHeader = (props: IProps) => {

  return (
    <div
      id="modal-header"
      className={props.className}
    >
      <img className="header-bg" src={Images.popup_header_bg_confetti} alt="confetti"/>
      <span className="text">{props.text}</span>
      {
        props.icon &&
        <div className="icon-wrapper">
          {props.icon}
        </div>
      }
    </div>
  );
}

export default ModalHeader;
